export interface AddressPart {
  administrative_area_level_1: string;
  administrative_area_level_2?: string;
  country: string;
  lat: number;
  lng: number;
  locality: string;
  postal_code?: string;
  route: string;
  street_number?: string;
  sublocality_level_1?: string;
}

export const googlePlacesDictionary = {
  street_number: 'short_name',
  route: 'long_name',
  locality: 'long_name',
  // Some regions (e.g. parts of Brazil) may omit `locality` and instead return city-like
  // information under `administrative_area_level_2`.
  administrative_area_level_2: 'long_name',
  administrative_area_level_1: 'short_name',
  country: 'long_name',
  postal_code: 'short_name',
  sublocality_level_1: 'short_name',
};

export type Place = {
  geometry?: {
    location: {
      lat: () => any;
      lng: () => any;
    };
  };
  address_components: any[];
  formatted_address: string;
  name: string;
};

export const parsePlace = (selectedPlace: Place): AddressPart => {
  const results = {} as AddressPart;

  selectedPlace.address_components?.forEach((addressComponent) => {
    const types: string[] = addressComponent.types || [];
    // Some components include multiple types; select the first one we know about.
    const matchedType = types.find((t) => !!googlePlacesDictionary[t]);
    if (!matchedType) return;

    results[matchedType] = addressComponent[googlePlacesDictionary[matchedType]];
  });

  if (selectedPlace?.geometry || selectedPlace?.geometry?.location) {
    results['lat'] = selectedPlace.geometry.location.lat();
    results['lng'] = selectedPlace.geometry.location.lng();
  } else {
    console.error(`No geometry location found in place ${selectedPlace?.name}`);
  }

  return results;
};
